import React, { useState } from 'react';
import { Modal } from 'react-bootstrap'
import './FloorPlanModalDetails.scss'

const FloorPlanModalDetails = (props) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            {props.icon ?
                <a href="javascript:void(0)" onClick={handleShow}>
                    <i className="icon-camera"></i>
                    { props.image_count ? <span>{props.image_count}</span> : '' }
                </a>
            :
                <a href="javascript:void(0)" onClick={handleShow} className="tag">
                    Floorplans
                </a>
            }

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                centered
                size="lg"
                dialogClassName="floorplan-large-modal"
                className="floorplan_modal"
            >
                <Modal.Header closeButton>
                </Modal.Header>
                    <Modal.Body className="text-center">
                        {props.floorplanimg?.includes(".pdf") ?<iframe src={props?.floorplanimg} width="100%" height="500px"></iframe>:
                        <img src={props.floorplanimg} className="img-fluid m-0 modal-img" />}
                    </Modal.Body>
            </Modal>
        </>
    );
}

export default FloorPlanModalDetails;